import { type AnyAction } from 'redux';
import { get, omit } from 'lodash';
import { GET_ENTITY } from '../actions/actionTypes/entities';
import { LOGOUT } from '../actions/actionTypes/user';
import { SEND_REQUEST, SEND_REQUEST_FAIL, SEND_REQUEST_SUCCESS } from '../actions/actionTypes/request';
import { type EntitiesState } from '../types';

export const initialState: EntitiesState = {
    current: {},
    previous: {}
};

function requestSuccessReducer(state: Record<string, any>, action: AnyAction): Record<string, any> {
    const { payload = {}, meta = {} } = action;
    const { requestType = '' } = meta;
    const entities = get(payload, 'data.entities', {});
    switch (requestType) {
        case GET_ENTITY: {
            return { ...state, ...entities };
        }
    }

    return state;
}

export const entities = (state = initialState, action: AnyAction): EntitiesState => {
    const { type, meta = {} } = action;

    switch (type) {
        case SEND_REQUEST: {
            return {
                current: state.current,
                previous: state.current
            };
        }
        case SEND_REQUEST_SUCCESS: {
            return {
                ...state,
                current: requestSuccessReducer(state.current, action)
            };
        }
        case SEND_REQUEST_FAIL: {
            if (meta.clearOnFail) {
                return {
                    current: omit({ ...state.current }, [meta.entityName]),
                    previous: state.current
                };
            }

            return state;
        }
        case LOGOUT: {
            return initialState;
        }
        default: {
            return state;
        }
    }
};
